module.exports = __webpack_public_path__ + "static/media/photo.38a828bc.jpg";